<template>
    <NuxtLayout name="malt-full-layout" class="company-payments-page-layout">
        <div class="company-payments-main">
            <slot />
        </div>
    </NuxtLayout>
</template>
